import { ControlledCheckbox } from 'components/Form';

import type { ICellRendererParams } from 'ag-grid-community';
import type { Control } from 'react-hook-form';

interface TCheckboxCellRenderer<T> extends ICellRendererParams<T> {
    control: Control;
}

export const GroupManagerCheckboxCellRenderer = <T extends { costGroup?: any; actId?: number; actKC2Id?: number }>(
    props: TCheckboxCellRenderer<T>,
) => {
    const { control, data } = props;

    const checkboxName =
        (data?.actId || data?.actKC2Id) && data?.costGroup
            ? `actKC2Ids.${data?.costGroup}_${data?.actId ?? data?.actKC2Id}`
            : 'unknownId';

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '2px',
            }}
        >
            {(data?.actId || data?.actKC2Id) && <ControlledCheckbox control={control} name={checkboxName} />}
        </div>
    );
};

GroupManagerCheckboxCellRenderer.displayName = 'GroupManagerCheckboxCellRenderer';
